module.exports = __webpack_public_path__ + "static/media/VestasSans-Bold.bf9941de.woff";